import {PopoverMenuItemType} from "../../../../gd-components/popover-menu/popover-menu/const";
import React from "react";
import ProjectSession from "../../../../model2/project/project-session";
import IconSelector from "../../../../gd-components/selector/icon-selector/icon-selector";
import {PROJECT_ICON_CATEGORIES} from "../../../../gd/const/item-icon/project-categories";
import {IconType} from "../../../../gd-components/selector/icon-selector/@const";
import {changeProjectIcon} from "../actions/change-project-icon";


export default function moreProject_SelectIcon(project: ProjectSession, options:Option[], disabled:boolean) {

    const onChange = (icon:string)=> {
        changeProjectIcon(project, icon)
    }

    options.push({
        type            : PopoverMenuItemType.CUSTOM_POPOVER,
        label           : "Change icon",
        icon            : "ii5-image",
        menuComponent   : (params:any)=>{
            return <IconSelector iconCategories = {PROJECT_ICON_CATEGORIES}
                                 iconTypes      = {[IconType.ITEM_ICONS, IconType.EMOJI_ICONS, IconType.URL]}
                                 // icon           = {params.menuParams.project.icon}
                                 icon           = {project.projectIcon}
                                 onChange       = {onChange}/>
        },
        disabled        : disabled,
    })
}
